import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import { CODE_ERRORS, ENDPOINT_API_PATH } from '../Definitions/TokenSmsDef';

const autoGenerateSuccess = (token: string) => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      body: null,
      params: {
        token,
      },
    },
    configResponse: {
      status: 200,
      data: {},
      headers: {},
    },
  };
  return validateSuccess;
};

const autoGenerateSuccessToken = autoGenerateSuccess(MocksDef.TOKEN_NUMBER);

const generatedSuccessMocks = [autoGenerateSuccessToken];

const autoGenerate = (token: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const params = {
        token: `${token.slice(0, -1)}${index}`,
      };
      const body = {};
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          params,
          body,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const reseponseToken = autoGenerate(MocksDef.TOKEN_NUMBER);
  return [...reseponseToken];
};

const errorsGenerated = autoGenerateErrorsMock();

const ValidateMocks = [...generatedSuccessMocks, ...errorsGenerated];
export default ValidateMocks;
